import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { repairStaleEconomics } from 'src/features/RecipeBuilderSlice'
import {
  hasStaleEconomicsRepairSession,
  markStaleEconomicsRepairSession,
} from 'src/utils/menuBuilderStaleEconomicsRepairSession'
import { shouldRunSilentStaleEconomicsRepair } from 'src/utils/silentStaleEconomicsRepair'

export const useSilentStaleEconomicsRepair = ({
  venueId,
  staleRecipeIds = [],
  enabled = true,
} = {}) => {
  const dispatch = useDispatch()
  const inFlightRef = useRef(false)
  const staleIdsKey = staleRecipeIds.join(',')

  useEffect(() => {
    if (inFlightRef.current) {
      return
    }

    const shouldRepair = shouldRunSilentStaleEconomicsRepair({
      enabled,
      venueId,
      staleRecipeIds,
      hasRepairSession: hasStaleEconomicsRepairSession(venueId),
    })

    if (!shouldRepair) {
      return
    }

    inFlightRef.current = true

    const runRepair = async () => {
      try {
        await dispatch(repairStaleEconomics(venueId, staleRecipeIds))
        markStaleEconomicsRepairSession(venueId)
      } catch {
        // Silent repair — allow retry on a later render if the request failed.
      } finally {
        inFlightRef.current = false
      }
    }

    void runRepair()
  }, [dispatch, venueId, enabled, staleIdsKey])
}

export default useSilentStaleEconomicsRepair
